/** Name of the Cache Storage bucket holding cached book covers. */
export const SW_COVERS_CACHE_KEY = `covers`

export const getCoverIdFromUrl = (url: URL) => {
  const pathname = url.pathname
  const pathParts = pathname.split(`/`)
  const id = pathParts[pathParts.length - 1]

  return id
}

export const getMetadataFromRequest = (request: Request) => {
  const coverId = request.headers.get(`oboku-sw-cover-id`) || `-1`
  const coverTimeCached = parseInt(
    request.headers.get(`oboku-sw-time-cached`) || "0",
    10,
  )

  return {
    coverId,
    coverTimeCached,
  }
}
